module.exports = __webpack_public_path__ + "img/Online payment Icon - white.ef897566.svg";